import {
  Box,
  Typography,
  Chip,
  CircularProgress,
  LinearProgress,
  Tooltip,
  Button,
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import ReplayIcon from '@mui/icons-material/Replay';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';

export default function RunCardHeader({
  run,
  statusColor,
  isRerunning,
  onRerun,
  onNavigateToEvents,
  datesMatch,
  startedDate,
  finishedDate,
  startedTime,
  finishedTime,
  elapsedTime,
}) {
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent={'space-between'}
        gap={1}
        mb={1}
        mt={1}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Chip label={run.status.toUpperCase()} color={statusColor} size="small" />
          {run.platform && (
            <Tooltip title={run.platform === 'ios' ? 'iOS' : 'Android'}>
              {run.platform === 'ios' ? (
                <AppleIcon fontSize="small" sx={{ color: 'text.secondary' }} />
              ) : (
                <AndroidIcon fontSize="small" sx={{ color: 'success.light' }} />
              )}
            </Tooltip>
          )}

          <Typography variant="h6">
            {run.scenarioId ? `${run.flowId} / ${run.scenarioId}` : run.flowId}
          </Typography>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          sx={{ alignSelf: { xs: 'flex-end', sm: 'flex-start' } }}
        >
          {run.status !== 'completed' && run.status !== 'running' && (
            <Button
              variant="outlined"
              size="small"
              startIcon={isRerunning ? <CircularProgress size={14} /> : <ReplayIcon />}
              onClick={onRerun}
              disabled={isRerunning}
            >
              Rerun
            </Button>
          )}
          {run.status === 'completed' && run.status !== 'running' && (
            <Button
              variant="outlined"
              size="small"
              onClick={onNavigateToEvents}
              disabled={isRerunning}
            >
              To Events
            </Button>
          )}
        </Box>
      </Box>
      <Box mb={1.5}>
        <Box
          display="flex"
          alignItems="flex-start"
          justifyContent="space-between"
          sx={{ flexDirection: { xs: 'column', sm: 'row' } }}
        >
          <Box>
            <Box
              display="flex"
              alignItems="center"
              flexWrap="wrap"
              gap={1.5}
              color="text.secondary"
            >
              <Box display="flex" alignItems="center" gap={1}>
                <CalendarTodayOutlinedIcon fontSize="small" color="action" />
                {datesMatch ? (
                  <Typography variant="body2" color="text.secondary">
                    {startedDate}
                  </Typography>
                ) : (
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="body2" color="text.secondary">
                      {startedDate}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      -
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {finishedDate}
                    </Typography>
                  </Box>
                )}
              </Box>

              <Box
                sx={{
                  height: 20,
                  borderLeft: '1px solid',
                  borderColor: 'divider',
                  display: { xs: 'none', sm: 'block' },
                }}
              />

              <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                <AccessTimeIcon fontSize="small" color="action" />
                <Typography variant="body2" color="text.secondary">
                  {startedTime} - {finishedTime}
                </Typography>
              </Box>

              <Box
                sx={{
                  height: 20,
                  borderLeft: '1px solid',
                  borderColor: 'divider',
                  display: { xs: 'none', sm: 'block' },
                }}
              />

              <Box display="flex" alignItems="center" gap={1}>
                <TimerOutlinedIcon fontSize="small" color="action" />
                <Typography variant="body2" color="text.secondary">
                  {elapsedTime}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      {run.status === 'running' && <LinearProgress color="warning" sx={{ mb: 2 }} />}
    </>
  );
}
